import { render, staticRenderFns } from "./PCPVVibBl.vue?vue&type=template&id=0c1b31c3&scoped=true&"
import script from "./PCPVVibBl.vue?vue&type=script&lang=js&"
export * from "./PCPVVibBl.vue?vue&type=script&lang=js&"
import style0 from "./PCPVVibBl.vue?vue&type=style&index=0&id=0c1b31c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1b31c3",
  null
  
)

/* custom blocks */
import block0 from "./PCPVVibBl.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports